import { IHavePath } from "../types/IHavePath";

export interface IInstallChecklist {}

export const InstallChecklistMeta: IHavePath = { path: "/install-checklist" };
